import * as React from 'react';

import OptionPackList from './OptionPackList';
import Modal, {
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
} from '../../common/modal';

export interface IOptionPackModalProps {
    isOpen: boolean;
    onDone: (selectedOptionPack) => void;
    onCancel: () => void;
}

export default class OptionPackModal extends React.Component<
    IOptionPackModalProps,
    any
> {
    state = {
        selectedOptionPack: null
    };

    setSelectedOptionPack = (selectedOptionPack) => {
        this.setState({
            selectedOptionPack
        });
    };

    handleSave = () => {
        this.props.onDone(this.state.selectedOptionPack);
    };

    render() {
        const { props } = this;
        const isDoneEnabled = !!this.state.selectedOptionPack;
        return (
            <Modal
                isOpen={props.isOpen}
                className={'modal-dialog--media-library media-library'}
            >
                <ModalHeader onClose={props.onCancel}>
                    {/* <ModalTitle>Select or upload media</ModalTitle> */}
                    <ModalTitle>Option Library</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <OptionPackList
                        selectedOptionPack={this.state.selectedOptionPack}
                        setOptionPack={this.setSelectedOptionPack}
                        as={'modal'}
                    />
                </ModalBody>
                <ModalFooter>
                    <button
                        className="btn btn--sm btn--transparent m-r-10"
                        onClick={props.onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className={`btn btn--sm btn--green ${
                            isDoneEnabled ? '' : 'disabled'
                        }`}
                        onClick={this.handleSave}
                        disabled={!isDoneEnabled}
                    >
                        Done
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
}
